module.exports = __webpack_public_path__ + "img/gaingels.160d86ae.png";